import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section className="w-full bg-white py-16 sm:py-20" aria-labelledby="faq-title" data-id="element-127" data-mp="2e0zeb43ucee4">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-128" data-mp="291mm03u7af45">
        <Reveal data-id="element-129" data-mp="2924npfzmtljg">
          <h2 id="faq-title" className="text-center font-display text-2xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-130" data-mp="28ziivo44lk4x">
            Preguntas <span className="text-tangerine" data-id="element-131" data-mp="1z2xen4zxkd25">frecuentes</span>
          </h2>
        </Reveal>

        <div className="mt-10 space-y-3" data-id="element-132" data-mp="soej884lov9a">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <Reveal key={f.q} delay={i * 0.04} data-id="element-133" data-mp="phxzdeh43rr9" data-mpi={i}>
                <div className="overflow-hidden rounded-2xl border border-navy/10 bg-cream" style={{
              borderLeft: `5px solid ${['#2D8C5A', '#6CBBD5', '#F3A340', '#F27C70', '#F6C453', '#8E7CC3'][i % 6]}`
            }} data-id="element-134" data-mp="pih947wlz9u7">
                  <h3 data-id="element-135" data-mp="6rge1uylzyfx">
                    <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-cream2 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-navy" data-id="element-136" data-mp="6r6kjxecv95h">
                      <span className="font-display text-sm font-extrabold uppercase leading-snug text-navy sm:text-base" data-id="element-137" data-mp="3o03bebo1chcy">
                        {f.q}
                      </span>
                      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-138" data-mp="1pq4igmfrkexg">
                        {isOpen ? <MinusIcon className="h-4 w-4 text-brandgreen" aria-hidden="true" data-id="element-139" data-mp="1krt541q9fmah" /> : <PlusIcon className="h-4 w-4 text-brandgreen" aria-hidden="true" data-id="element-140" data-mp="1fpvicxini9cs" />}
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-141" data-mp="28ej7x5afnkw5">
                    {isOpen && <motion.div id={`faq-panel-${i}`} initial={reduce ? undefined : {
                  height: 0,
                  opacity: 0
                }} animate={reduce ? undefined : {
                  height: 'auto',
                  opacity: 1
                }} exit={reduce ? undefined : {
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.28,
                  ease: [0.22, 1, 0.36, 1]
                }} className="overflow-hidden" data-id="element-142" data-mp="23fpsh7bl5jtc">
                        <p className="px-5 pb-5 font-sans text-sm leading-relaxed text-muted" data-id="element-143" data-mp="33qit97que2vh">
                          {f.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>

      </div>
    </section>;
}